// order sheet — the native, app-owned version of the yard's "SHEET 27" order list. SAP / MODEL /
// NAME identify each vessel (they come from the season overview); every other column below is an
// editable spec cell, stored per vessel as a JSON map keyed by the column's spreadsheet letter.
// The letter is the stable key so a re-labelled or duplicated header never collides.
/** the editable spec columns (spreadsheet D…DJ); SAP/MODEL/NAME are identity and not stored here. */
export const ORDER_SHEET_COLUMNS = [
    { key: 'D', label: 'SET UP:' },
    { key: 'E', label: 'LAYOUT:' },
    { key: 'F', label: 'BOW:' },
    { key: 'G', label: 'STERN:' },
    { key: 'H', label: 'FIRST ROW OF SEATS' },
    { key: 'I', label: 'SECOND ROW OF SEATS' },
    { key: 'J', label: 'COLORS:' },
    { key: 'K', label: 'UPHOLSTERY COLOR:' },
    { key: 'L', label: 'HULL COLOR:' },
    { key: 'M', label: 'DECK COLOR:' },
    { key: 'N', label: 'TUBES:' },
    { key: 'O', label: 'PROTECTION FENDER:' },
    { key: 'P', label: 'FLOORING' },
    { key: 'Q', label: 'ENGINES:' },
    { key: 'R', label: 'PRE-RIGGING' },
    { key: 'S', label: 'NUMBER OF' },
    { key: 'T', label: 'MERCURY' },
    { key: 'U', label: 'YAMAHA' },
    { key: 'V', label: 'VOLVO' },
    { key: 'W', label: 'YANMAR' },
    { key: 'X', label: 'ENGINE PERIPHERALS' },
    { key: 'Y', label: "MERCURY VESSEL VIEW 7''" },
    { key: 'Z', label: "VOLVO SCREEN 9''" },
    { key: 'AA', label: "YAMAHA SCREEN 5''" },
    { key: 'AB', label: "YAMAHA SCREEN 7''" },
    { key: 'AC', label: 'HYDRAULIC STEERING' },
    { key: 'AD', label: 'ELECTRIC STEERING' },
    { key: 'AE', label: 'JOYSTICK' },
    { key: 'AF', label: 'RAYMARINE AUTOPILOT' },
    { key: 'AG', label: 'EXTRAS:' },
    { key: 'AH', label: 'INSTRUMENTS:' },
    { key: 'AI', label: 'RAYMARINE' },
    { key: 'AJ', label: 'GARMIN' },
    { key: 'AK', label: '110V' },
    { key: 'AL', label: '220V' },
    { key: 'AM', label: "16'' SCREEN" },
    { key: 'AN', label: "12'' SCREEN" },
    { key: 'AO', label: "9'' SCREEN" },
    { key: 'AP', label: 'SECOND SCREEN SAME SIZE' },
    { key: 'AQ', label: 'THIRD SCREEN SAME SIZE' },
    { key: 'AR', label: 'VHF' },
    { key: 'AS', label: 'GMDSS' },
    { key: 'AT', label: 'AIS-B' },
    { key: 'AU', label: 'FUSION 6 SPEAKERS, 2 AMPLIFIERS, 1 SUBWOOFER' },
    { key: 'AV', label: 'FUSION 4 SPEAKERS' },
    { key: 'AW', label: 'THERMAL CAMERA' },
    { key: 'AX', label: 'RADAR' },
    { key: 'AY', label: 'REMOTE SEARCH LIGHT' },
    { key: 'AZ', label: 'DECK & COCKPIT' },
    { key: 'BA', label: 'T-TOP' },
    { key: 'BB', label: 'UPGRADE TO SHOXS SEATS' },
    { key: 'BC', label: '2ND ROW SEATS' },
    { key: 'BD', label: 'BACK TO BACK WITH FRIDGE' },
    { key: 'BE', label: 'CABIN FRIDGE' },
    { key: 'BF', label: 'WET BAR' },
    { key: 'BG', label: '2ND FRIDGE WET BAR' },
    { key: 'BH', label: 'ELECTRIC TABLE' },
    { key: 'BI', label: 'TABLE' },
    { key: 'BJ', label: 'SUN TENT AFT' },
    { key: 'BK', label: 'SUN TENT BOW' },
    { key: 'BL', label: 'T-TOP SIDE TENTS' },
    { key: 'BM', label: 'AFT SIDE TENTS' },
    { key: 'BN', label: 'SUN TENT CLASSIC' },
    { key: 'BO', label: 'BOW TOWING EYES' },
    { key: 'BP', label: 'SKI POLE' },
    { key: 'BQ', label: 'ROLLBAR' },
    { key: 'BR', label: 'CABIN IN AFT LOCKER' },
    { key: 'BS', label: 'CABIN IN BOW LOCKER' },
    { key: 'BT', label: 'CARBON SHOWER' },
    { key: 'BU', label: 'ELECTRIC EQUIPMENT' },
    { key: 'BV', label: 'UNDERWATER' },
    { key: 'BW', label: 'SHOREPOWER' },
    { key: 'BX', label: 'BOW THRUSTER' },
    { key: 'BY', label: 'SOLAR PANEL' },
    { key: 'BZ', label: 'LED BAR' },
    { key: 'CA', label: 'PORTABLE FRIDGE' },
    { key: 'CB', label: 'TOILET' },
    { key: 'CC', label: 'ELECTRIC AFT HATCH' },
    { key: 'CD', label: 'WINDLASS' },
    { key: 'CE', label: 'TRIM TABS' },
    { key: 'CF', label: 'WASH DOWN' },
    { key: 'CG', label: 'COFFE MAKER' },
    { key: 'CH', label: 'A/C' },
    { key: 'CI', label: 'INVERTER' },
    { key: 'CJ', label: 'GENERATOR' },
    { key: 'CK', label: 'WATER HEATER' },
    { key: 'CL', label: 'AFT WINDLASS' },
    { key: 'CM', label: 'AFT ANCHOR' },
    { key: 'CN', label: 'ACCESSORIES' },
    { key: 'CO', label: 'ANTIFOULING' },
    { key: 'CP', label: 'TRAILER' },
    { key: 'CQ', label: 'PARKING COVER' },
    { key: 'CR', label: 'CONSOLE COVER' },
    { key: 'CS', label: 'SEATS COVER' },
    { key: 'CT', label: 'TOWING ROPES' },
    { key: 'CU', label: 'SHRINK WRAP' },
    { key: 'CV', label: 'ADITIONAL REQUESTS:' },
    { key: 'CW', label: 'AR1' },
    { key: 'CX', label: 'AR2' },
    { key: 'CY', label: 'AR3' },
    { key: 'CZ', label: 'AR4' },
    { key: 'DA', label: 'AR5' },
    { key: 'DB', label: 'AR6' },
    { key: 'DC', label: 'AR7' },
    { key: 'DD', label: 'AR8' },
    { key: 'DE', label: 'AR9' },
    { key: 'DF', label: 'AR10' },
    { key: 'DG', label: "9'' SCREEN (2)" },
    { key: 'DH', label: "16''" },
    { key: 'DI', label: "12''" },
    { key: 'DJ', label: "9''" },
];
/** the set of valid column keys, for validating writes. */
export const ORDER_SHEET_KEYS = new Set(ORDER_SHEET_COLUMNS.map((c) => c.key));
export const isOrderSheetKey = (k) => ORDER_SHEET_KEYS.has(k);
// Reserved (non-letter) keys stored inside a row's cell map to carry the identity of a vessel that
// exists ONLY in the imported Excel — i.e. it isn't on the season's Smartsheet overview (a stock boat,
// or one with no/unknown SAP). For overview vessels the identity comes from the overview, so these are
// only written for orphan rows. They can never collide with a spreadsheet column letter.
export const OS_NAME_KEY = '#name';
export const OS_MODEL_KEY = '#model';
/** reserved identity keys that a row's cell map may carry in addition to the spec-column letters. */
export const isOrderSheetIdentityKey = (k) => k === OS_NAME_KEY || k === OS_MODEL_KEY;
//# sourceMappingURL=orderSheet.js.map